import { ROUTES } from '@Constants/navigation.contants';
export { ACTIVE_SERVICE_COOKIE } from '@Constants/navigation.contants';

export interface ServiceMeta {
    href: string;
    defaultHref: string;
    isEnabled: boolean;
}

export const SERVICES_META: readonly ServiceMeta[] = [
    { href: ROUTES.HUB,        defaultHref: ROUTES.PRODUCTS,   isEnabled: true },
    { href: ROUTES.SCOUT,      defaultHref: ROUTES.SEARCH,     isEnabled: true },
    { href: ROUTES.CALCULATOR, defaultHref: ROUTES.CALCULATOR, isEnabled: true },
] as const;

export const FIRST_ENABLED_SERVICE: ServiceMeta = (() => {
    const s = SERVICES_META.find(x => x.isEnabled);
    if (!s) throw new Error('No enabled services found.');
    return s;
})();


export const findServiceByHref = (href?: string | null) =>
    href ? SERVICES_META.find(s => s.href === href && s.isEnabled) ?? null : null;

export const findServiceByPathname = (pathname: string) => {
    const seg = '/' + (pathname.split('/')[1] || '');
    return findServiceByHref(seg);
};


export const SETTINGS_ROUTES = [ROUTES.SETTINGS, ROUTES.SETTINGS_ACCOUNT] as const;

export const isSettingsRoute = (pathname: string) =>
    SETTINGS_ROUTES.some(r => pathname.startsWith(r));

/**
 * WE-115: the 'hub'|'scout' vocabulary used by every service_* analytics
 * field (page_view.service, service_switched.to_service, getEventContext's
 * service context) — single source, so a route change can't update one
 * mapping and silently leave the other stale (already happened once: this
 * mapping used to only exist in enricher.ts, compared against the wrong
 * cookie format, and returned null for every event since Wave 0).
 */
export const pathToServiceName = (path: string): 'hub' | 'scout' | null => {
    if (path.startsWith(ROUTES.HUB)) return 'hub';
    if (path.startsWith(ROUTES.SCOUT)) return 'scout';
    return null;
};
